import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_USER_QUALIFICATIONS =
  "SET_IS_FETCHING_USER_QUALIFICATIONS";
export const SET_CURRENT_USER_QUALIFICATIONS =
  "SET_CURRENT_USER_QUALIFICATIONS";

const mutations = {
  [SET_IS_FETCHING_USER_QUALIFICATIONS]: setStoreValue(
    "isFetchingUserQualifications"
  ),
  [SET_CURRENT_USER_QUALIFICATIONS]: setStoreValue("currentUserQualifications")
};

const state = {
  currentUserQualifications: [],
  isFetchingUserQualifications: false
};

export { mutations, state };
